import Utils from './Utils';

export default class ModuleForm {
    init() {
        if (!Utils.isRingSizeProduct()) {
            return;
        }

        $(document)
            .off('click.arsRingSize', '.ars-form__size')
            .on('click.arsRingSize', '.ars-form__size', (event) => {
                const $button = $(event.currentTarget);
                const value = $button.data('value');
                const $field = $('#ars-ring-sizes');

                $field.val(value).trigger('change');

                $('.ars-form__value').text(value);
                $('.ars-form__size').removeClass('linked-products__link--current');
                $button.addClass('linked-products__link--current');

                $('#collapse-ars-ring-sizes').collapse('hide');
            });

        $('#ars-ring-sizes').on('change', () => {
            Utils.showLoader();
            this.updateCustomization()
                .catch(() => {
                    console.error(
                        'An error occurred while updating customization'
                    );
                })
                .finally(() => {
                    Utils.hideLoader();
                    document.dispatchEvent(new Event('arsRingSizeUpdate'));
                });
        });
    }

    /* Prepare form to send data through ajax */
    getFormObject() {
        const form = new FormData();
        const field = $('#ars-ring-sizes');

        if (field.length < 1) {
            return;
        }

        form.append(field.prop('name'), field.val() ? field.val() : '');
        form.append('submitCustomizedData', 1);

        return form;
    }

    /* Make AJAX call to update product customization (save ring size value) */
    updateCustomization() {
        const form = this.getFormObject();

        return new Promise((resolve, reject) => {
            $.ajax({
                type: 'POST',
                url: window.location.href,

                data: form,
                dataType: 'html',

                processData: false,
                contentType: false,

                success: function (response) {
                    let currentCustomization = $('#product_customization_id');

                    if (!response) {
                        reject(new Error('Invalid response'));
                    }

                    let newCustomization = $(response).find(
                        '#product_customization_id'
                    );

                    let newValue = newCustomization.val();

                    currentCustomization.val(newValue);

                    resolve();
                },
                error: function (error) {
                    reject(error);
                },
            });
        });
    }

    static isValid() {
        return !!$('#ars-ring-sizes').val();
    }
}
